/* eslint-disable */
import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { userSignup } from "../../services/user";
import { useNavigate } from "react-router-dom";
import { md5 } from "js-md5";
import "../D5Login/index.css";
import { TriggerEmailApi } from "../../api/Api";

function SignupPage() {
	const navigate = useNavigate();

	const handleSendCode = async (email: string) => {
		if (!email || email == "") {
			message.error("请输入 Email");
			return;
		}
		try {
			const res = await TriggerEmailApi({
				email: email,
			});
			if (res) {
				message.success("Verification code sent");
			}
		} catch (e: any) {
			message.error(e?.message);
		}
	};

	const handleSubmit = async (values: any) => {
		try {
			const res = await userSignup({
				name: values?.username,
				email: values?.email,
				password: md5(values?.password),
			});
			if (res) {
				message.success("Sign Up successfully");
				handleSendCode(values?.email);
				navigate("/verify", { state: { email: values?.email } });
			}
		} catch (e: any) {
			message.error(e?.message ?? e?.toString());
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	return (
		<div className="login-wrapper">
			<div className="glow-bg-2"></div>
			<div className="login-wrapper-main">
				<div className="login-left">
					<div className="login-left-top">
						<div className="login-left-top-gradient">
							欢迎使用 点灵数据搜集平台
						</div>
						<div className="login-left-top-subtitle">
							第五维度打造的点灵数据搜集平台，是一款高效数据获取工具 <br />
							以对话的形式，提供文本、图片等数据跨模态检索，并支持互联网公开数据和私有数据部署
							<br />
							为AI模型训练提供高质量数据
							<br />
						</div>
					</div>
					<div className="login-left-title-wrapper">
						<video
							width="100%"
							controls
							autoPlay
							muted
							style={{ border: "none", outline: "none", borderRadius: "10px" }}
						>
							<source src="../../datagptdemo.mp4" type="video/mp4" />
							Your browser does not support the video tag.
						</video>
					</div>
				</div>
				<div className="dlp">
					<div className="login-card-wrapper">
						<div className="login-card-header">
							<div className="login-card-title">创建账户</div>
							<div className="login-card-subtitle">
								欢迎加入杭州五维数据有限责任公司
							</div>
						</div>
						<Form
							name="basic"
							layout="vertical"
							initialValues={{ remember: true }}
							onFinish={handleSubmit}
							onFinishFailed={onFinishFailed}
							autoComplete="off"
						>
							<Form.Item
								label="账户"
								name="username"
								rules={[
									{ required: true, message: "Please input your username!" },
								]}
							>
								<Input style={{ height: "40px", width: "95%" }} />
							</Form.Item>

							<Form.Item
								label="邮箱"
								name="email"
								rules={[
									{ required: true, message: "Please input your email!" },
								]}
							>
								<Input style={{ height: "40px", width: "95%" }} />
							</Form.Item>

							<Form.Item
								label="密码登录"
								name="password"
								rules={[
									{ required: true, message: "Please input your password!" },
								]}
								style={{ marginBottom: "10px" }}
							>
								<Input.Password style={{ height: "40px", width: "95%" }} />
							</Form.Item>

							{/* <Form.Item
                name="remember"
                valuePropName="checked"
                label={null}
                style={{ marginBottom: "10px" }}
              >
                <Checkbox>记住密码</Checkbox>
              </Form.Item> */}

							<div className="login-more">
								已经注册？<a href="/login">去登录</a>
							</div>
							<Form.Item
								label={null}
								style={{ textAlign: "center", marginTop: 30 }}
							>
								<Button
									type="primary"
									htmlType="submit"
									style={{
										width: "80%",
										borderRadius: 10,
										padding: 20,
										fontSize: 17,
										margin: "0 auto 40px 0",
									}}
								>
									注册
								</Button>
							</Form.Item>
						</Form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SignupPage;
